@let
r = rec();

<div class="dialog-form">
	<app-input-wrapper blend class="flex-none" label="Type">
		<select [(ngModel)]="r.type" [classList]="'custom-input'">
			@for (
					type of VapeTypes; track type) {
				<option [value]="type">{{VapeTypesDict[type].name}}</option>
			}
		</select>
	</app-input-wrapper>

	@if (VapeTypesDry.includes(r.type)) {
		<app-input-wrapper blend class="flex-none" label="Strength" [descr]="(r.strength * 100).toFixed() + '%'">
			<input [(ngModel)]="r.strength" min="0" max="1" step="0.01" type="range"/>
		</app-input-wrapper>
	}

	@if (r.type === 'hybrid' && r.ratio) {
		<app-input-wrapper blend class="flex-none" label="Ratio" [descr]="r.ratio['indica'] + ':' + r.ratio['sativa']">
			<input [(ngModel)]="r.ratio['sativa']" min="0" max="100" step="10" type="range" (input)="onRatioChange()"/>

		</app-input-wrapper>
	}

	<app-input-wrapper blend class="flex-none" label="QTY" [descr]="r.qtyMg.toFixed(0) + 'mg'">
		<input [(ngModel)]="r.qtyMg" min="0" max="300" step="10" type="range"/>
	</app-input-wrapper>


	<app-input-wrapper blend class="flex-none" label="Temp" [descr]="r.temp+'ºC'">
		<input [(ngModel)]="r.temp" type="range" id="heat" name="heat" min="100" max="300" step="10"/>
	</app-input-wrapper>

	<!--			@if (VapeTypesOil.includes(r.type) && r.oil) {-->
	<!--				<app-input-wrapper class="flex-none" label="Type">-->
	<!--					<select [(ngModel)]="r.oil.type" [classList]="'custom-input'">-->
	<!--						@for (oil of VapeOilSelect; track oil) {-->
	<!--							<option [value]="oil.value">{{ oil.label }}</option>-->
	<!--						}-->
	<!--					</select>-->
	<!--				</app-input-wrapper>-->
	<!--				<app-input-wrapper class="flex-none" label="Type">-->
	<!--					<input [(ngModel)]="r.oil.secs" type="number"/>-->
	<!--				</app-input-wrapper>-->
	<!--			}-->

</div>